import React, { Component } from 'react';
import i18n from 'i18n-react';
import { spring, StaggeredMotion } from 'react-motion';

import { baseAppId, storageKeys, imgixUrl } from 'settings';
import { APIHandler, ContentHeader, DataHandler, StorageHandler, SubAppButton, TrainingCard } from 'C4';
import clsx from 'clsx';

const trackShare = (chapterNumber) => {
  const value = `chapter-${chapterNumber}`;
  DataHandler.matchAppId().then((appId) => {
    StorageHandler.load(storageKeys.user).then((userObj) => {
      let email = '';
      ({ email } = userObj);
      APIHandler.trackEvent(appId, email, 'retention', 'chapter', value).then(() => {
      });
    });
  });
};

export default class RetainGrid extends Component {
  constructor(props) {
    super(props);
    this.state = {
      chapters: [],
      chapters_progress: [],
      lockedChapters: [],
      subApps: [],
      userCountry: '',
    };

    this.loadChapters = this.loadChapters.bind(this);
    this.calculateProgress = this.calculateProgress.bind(this);
  }

  componentWillMount() {
    this.mounted = true;
    this.getProgress();
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  getProgress() {
    StorageHandler.load(storageKeys.lang).then((lang) => {
      this.setState({ userCountry: lang.code });
    });

    StorageHandler.load(storageKeys.user).then((res) => {
      if (res) {
        const { email } = res;
        DataHandler.matchAppId().then((appId) => {
          this.setSubApps(appId);
          DataHandler.checkKey(storageKeys.progress, APIHandler.getUserProgress(appId, email))
            .then((userProgress) => {
              this.calculateProgress(userProgress);
            });
        });
      }
    });
    // this.setSubApps(baseAppId);
  }

  getSubAppProgress(appIds) {
    return StorageHandler.load(storageKeys.user).then((res) => {
      if (res) {
        const { email } = res;
        if (this.mounted && appIds.length > 0) {
          return APIHandler.getUserProgress(appIds, email)
            .then((userProgress) => {
              const progress = Object.values(userProgress.data).map((app) => {
                const [chapter] = app.chapters;
                const { name, region_hidden } = app;
                return {
                  chapter,
                  name,
                  region: region_hidden,
                };
              });
              return progress;
            });
        }
      }
      return null;
    });
  }

  setSubApps(appId) {
    const { userCountry } = this.state;
    return APIHandler.getSubApps(appId)
      .then((ids) => {
        const appIds = ids[0].sessions.map(function(item) {
          return item['session_app_id'];
        });
        this.getSubAppProgress(appIds).then((progress) => {
          if (progress) {
            StorageHandler.load(storageKeys.user).then((user) => {
              if (user) {
                const { email } = user;
                const subAppPromises = appIds.map((id, i) => {

                  if (progress[i].region === 1 && (userCountry === 'caEn' || userCountry === 'caFr')) {
                    return;
                  }

                  const pageId = progress[i].chapter.last_page < progress[i].chapter.total_pages
                ? progress[i].chapter.last_page
                : 0;
                const key = i;
              return APIHandler.getChapters(id)
                .then((chapter) => {
                  const [newApp] = chapter.app;
                  const backgroundImageSrc = `${imgixUrl}${id}/${newApp.chapterImage}?fit=crop&w=257&h=210`;

                  return (
                    <SubAppButton
                      key={`${key}_${newApp.chapterImage}`}
                      appId={id} 
                      pageId="0"
                      progress={progress[i].chapter}
                      name={progress[i].name}
                      type="retain"
                      size={{ height: 100, width: 100 }}
                      email={email}
                      backgroundImage={backgroundImageSrc}
                      chapterId={progress[i].chapter.chapter}
                    />
                  );
                });
            });
            if (this.mounted) {
              return Promise.all(subAppPromises)
                .then((subApps) => {
                  this.setState({ subApps });
                });
            } 
          }});
            return null;
          
          } return null;
        });
      });
  }

  isLocked(key) {
    const { chapters_progress: progress, userCountry } = this.state;

    if (key >= 6 && (userCountry === 'caEn' || userCountry === 'caFr' || userCountry === 'fr')) {
      return true;
    }

    if (key >= 8 && (userCountry === 'de')) {
      return true;
    }

    return false;
  }

  loadChapters(setProgress) {
    const { lockedChapters, userCountry } = this.state;
    DataHandler.matchAppId()
      .then(appId => (
        APIHandler.getChapters(appId)
          .then((res) => {
            const startingValues = [];
            Object.keys(res.app).map(() => {
              const newObj = {};
              newObj.data = 0;
              newObj.pos = 20;
              return startingValues.push(newObj);
            });
            if (!setProgress) {
              StorageHandler.load(storageKeys.user).then((user) => {
                APIHandler.registerUserProgress(user.email).then((registered) => {
                  if (registered) {
                    this.getProgress(); // This function rechecks user progress
                  }
                });
              });
            } else {
              const chapters = (
                <StaggeredMotion
                  defaultStyles={startingValues}
                  styles={prevInterpolatedStyles => prevInterpolatedStyles.map((_, i) => (i === 0
                    ? { data: spring(1, { stiffness: 320, damping: 28 }), pos: spring(0, { stiffness: 320, damping: 28 }) }
                    : { data: spring(prevInterpolatedStyles[i - 1].data, { stiffness: 320, damping: 28 }), pos: spring(prevInterpolatedStyles[i - 1].pos, { stiffness: 320, damping: 28 }) }))}
                >
                  {styles => (
                    <React.Fragment>
                      {res.app.map((chapter, key) => {
                        // let { percentage } = 0;
                        // if (this.state.chapters_progress[key] !== undefined) {
                        //   ({ percentage } = this.state.chapters_progress[key]);
                        // }
                        const { percentage } = this.state.chapters_progress[key];
                        // lockedChapters[key] = (percentage < 100 || percentage === undefined);
                        return (
                          <React.Fragment key={key}>
                            {key === 0 &&
                            <span className="subHeader">
                              <ContentHeader
                                header={i18n.translate('contentHeaders.maintrainings')}
                                subtitle={i18n.translate('pageDescriptions.maintrainings')}
                              />
                            </span>
                            }
                            {key === 4 &&
                            <span className="subHeader">
                              <ContentHeader
                                header={i18n.translate('contentHeaders.subtrainings')}
                                subtitle={i18n.translate('pageDescriptions.subtrainings')}
                              />
                            </span>
                            }
                            {((key !== 3 && userCountry === 'caFr') || (key !== 3 && userCountry === 'caEn') || (userCountry !== 'caEn' && userCountry !== 'caFr')) && 
                            <div key={key} onClick={() => trackShare(key + 1)} className={clsx('trainingCard__Animated', { specialization: key >= 4 })} style={{ opacity: `${styles[key].data}`, transform: `translateY(${styles[key].pos}%)` }}>
                              <TrainingCard
                                chapter={chapter}
                                chapterCount={chapter.chapterItemCount}
                                locked={this.isLocked(key)}
                                index={key}
                                appId={appId}
                                key={chapter.chapterID}
                                redirPath="/main/retain/chapter/"
                                lockedSubtitle={i18n.translate('trainingScreens.unlock', { number: key + 1 })}
                                lockedSubtitleRedirect="/main/training"
                              />
                            </div>}
            
                          </React.Fragment>
                        );
                      })}
                    </React.Fragment>
                  )}
                </StaggeredMotion>);
              this.setState({ chapters, lockedChapters });
            }
          })
      ));
  }

  calculateProgress(res) {
    if (res.status !== 'error') {
      const { chapters } = res.data[0];
      chapters.forEach((chapter) => {
        const newChapter = chapter;
        if (chapter.progress > 0 && chapter.total_pages > 0) {
          newChapter.percentage = (chapter.progress / chapter.total_pages) * 100;
          if (newChapter.percentage > 100) { newChapter.percentage = 100; }
        }
      });
      this.setState({ chapters_progress: chapters }, () => {
        this.loadChapters(res.status !== 'error');
      });
    }
    this.loadChapters(res.status !== 'error');
  }

  render() {
    const { lockedChapters, subApps, chapters } = this.state;
    const allUnlocked = lockedChapters.every(isLocked => isLocked === false);
    return (
      chapters && (
        <div className="wrapper__grid">
          <div className="trainingGrid">
            {chapters}
          </div>
          {subApps.length > 0 &&
            <ContentHeader
              header={i18n.translate('contentHeaders.subapps')}
              // subtitle={i18n.translate('pageDescriptions.subapps')}
            />
          }
          <div className="trainingGrid subApps">
            {subApps}
          </div>
        </div>
      )
    );
  }
}